import * as React from 'react';
import { isLinkAttribution, isPersonAttribution, } from './types';
export const AttributionTag = ({ to }) => {
    if (isLinkAttribution(to)) {
        return React.createElement("a", { href: to.uri }, to.uri);
    }
    else if (isPersonAttribution(to)) {
        return React.createElement(PersonAttributionTag, { ...to });
    }
    else {
        return null;
    }
};
const PersonAttributionTag = ({ webId, name, imageSrc, }) => {
    return (React.createElement(React.Fragment, null,
        imageSrc && React.createElement("img", { height: '47', width: '47', alt: name, src: imageSrc }),
        React.createElement("a", { href: webId }, name)));
};
//# sourceMappingURL=AttributionTag.js.map